// Server rows → mirror rows, for the few places where an older server wrote a row the screens would misread.
// • sales: before v10 the server voided a sale by setting voidedAt only, so `status` stayed 'completed' and a pulled row
//   un-voided the invoice on every device (recycle bin, reports and the invoice list all read `status`). voidedAt decides.

export function normalizeRow(entity: string, row: Record<string, unknown>): Record<string, unknown> {
  if (entity === 'sales') {
    const voided = row.voidedAt !== null && row.voidedAt !== undefined;
    if (voided && row.status !== 'voided') return { ...row, status: 'voided' };
    if (!voided && row.status === 'voided') return { ...row, status: 'completed' };
  }
  return row;
}
